import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, alpha, Divider, CircularProgress } from "@mui/material";
import CardImplementacion from "./CardImplementacion";
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../../../firebase/firebaseConfig";

const ProgramPages = () => {
    const [infoProgam, setInfoProgram] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, 'pageinfoprogramacalocho'),
            (snapshot) => {
                const arregloInfoProgram = snapshot.docs.map((docInfoProgram) => ({ ...docInfoProgram.data(), id: docInfoProgram.id }));
                setInfoProgram(arregloInfoProgram);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, []);

    // Carrusel: Actualizar el índice cada 10 segundos
    useEffect(() => {
        if (infoProgam.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % infoProgam.length);
            }, 10000); // 10000ms = 10s
            return () => clearInterval(interval);
        }
    }, [infoProgam.length]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: '#5d0303' }} />
            </Box>
        );
    }

    if (infoProgam.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6">No hay datos por mostrar</Typography>
            </Box>
        );
    }

    return (
        infoProgam.length > 0 &&
        <Box
            justifyContent="center"
            sx={(theme) => ({
                width: '100%',
                backgroundImage:
                  theme.palette.mode === 'light'
                    ? 'linear-gradient(180deg, #5d0303, #FFF)'
                    : `linear-gradient(#02294F, ${alpha('#090E10', 0.0)})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                padding: { xs: 2, sm: 4, md: 8 }, 
            })}
        >
            <Grid
                key={infoProgam[currentIndex].id}
                alignItems="center"
                justifyContent="center"
                sx={{
                    p: { xs: 2, sm: 4, md: 6 },
                    m: { xs: 0, sm: 3, md: 4 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: { xs: '100%', sm: '80%', md: '100%' },
                    mx: 'auto'
                }}
            >
                <Typography variant="h3" sx={{
                    marginBottom: { xs: '2%', sm: '3%' },
                    marginTop: { xs: '16%', sm: '3%' },
                    textAlign: 'center',
                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }
                }}>
                    {infoProgam[currentIndex].titulo}
                </Typography>
                <Typography variant="subtitle1" sx={{
                    marginBottom: { xs: '1%', sm: '2%' },
                    textAlign: 'center',
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }
                }}>
                    {infoProgam[currentIndex].subtitulo}
                </Typography>
                <Typography variant="subtitle1" sx={{
                    marginBottom: { xs: '1%', sm: '2%' },
                    textAlign: 'center',
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }
                }}>
                    {infoProgam[currentIndex].descripcion}
                </Typography>
                <Typography variant="subtitle1" sx={{
                    marginBottom: { xs: '1%', sm: '2%' },
                    textAlign: 'center',
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }
                }}>
                    {infoProgam[currentIndex].descripcion2}
                </Typography>
            </Grid>

            <CardImplementacion />

            <Divider
                sx={{
                    backgroundColor: 'linear-gradient(180deg, #FFF, #5d0303)',
                    width: '100%',
                    height: '2px',
                    my: { xs: 2, sm: 3 }
                }}
            />
        </Box>
    );
}

export default ProgramPages;